import { useTranslation } from "react-i18next";

import GenericDialog from "./generic";
import { JsonViewer } from "widgets/shared/jsonViewer";

const JsonDialog = (props: {
  isOpen: boolean;
  onClose: () => void;
  jsonData: any;
  title: string;
}) => {
  const { isOpen, onClose, jsonData, title } = props;
  const { t } = useTranslation();

  return (
    <GenericDialog
      isOpen={isOpen}
      title={title}
      onExit={onClose}
      onOk={onClose}
      size="lg"
    >
      <div className="flex max-h-[400px] w-full justify-center overflow-y-auto px-4">
        <JsonViewer data={jsonData} />
      </div>
    </GenericDialog>
  );
};

export default JsonDialog;
